import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_364: DocMigration = {
  maxSchemaVersion: "0.0.364",
  description: "Rename OptionState parameter to OptionPreset parameter",
  apply(json: any) {
    if (!json.parameters) {
      return json;
    }

    for (const paramId in json.parameters) {
      const param = json.parameters[paramId];
      if (param.type === "OPTION_STATE") {
        param.type = "OPTION_PRESET";
      }
    }

    return json;
  },
};

export default migration_0_0_364;
